import Swiper from 'swiper/bundle';

function awardsSwiper() {
  const swiper = new Swiper('.js-awards-swiper', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 0,
    speed: 1000,
    grid: { rows: 1 },
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        grid: {
          rows: 1,
        },
      },
      640: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        grid: {
          rows: 1,
        },
      },
    },
  });
}

export default awardsSwiper;